(() => {
  if (!customElements.get('uke-cart-shipping-progress')) {
    class UkeCartShippingProgress extends HTMLElement {
      connectedCallback() {
        this.refresh = this.refresh.bind(this);
        this.refresh();
        this.notificationObserver = new MutationObserver(() => {
          if (this.closest('cart-notification')?.querySelector('.cart-notification.active')) this.refresh();
        });
        const notification = this.closest('cart-notification')?.querySelector('.cart-notification');
        if (notification) this.notificationObserver.observe(notification, { attributes: true, attributeFilter: ['class'] });
      }
      disconnectedCallback() { this.notificationObserver?.disconnect(); }
      async refresh() {
        try {
          const response = await fetch(`${routes.cart_url}.js`);
          const cart = await response.json();
          const threshold = Number(this.dataset.threshold || 7900);
          const unlocked = cart.total_price >= threshold;
          const remainder = Math.max(threshold - cart.total_price, 0);
          const currency = cart.currency || 'USD';
          const amount = new Intl.NumberFormat(undefined, { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(remainder / 100);
          this.classList.toggle('is-unlocked', unlocked);
          this.querySelector('[data-uke-shipping-message]').textContent = unlocked ? this.dataset.unlockedMessage : this.dataset.remainingTemplate.replace('[amount]', amount);
          this.querySelector('[data-uke-shipping-fill]').style.setProperty('--uke-shipping-progress', `${Math.min((cart.total_price / threshold) * 100, 100)}%`);
        } catch (_) { /* The server-rendered state remains available if the cart endpoint is unavailable. */ }
      }
    }
    customElements.define('uke-cart-shipping-progress', UkeCartShippingProgress);
  }

  const loadRecommendations = (section) => {
    if (!section?.dataset.url || section.dataset.loaded === 'true') return;
    section.dataset.loaded = 'true';
    fetch(section.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const replacement = documentFragment.querySelector('#uke-cart-recommendations .uke-cart-recommendations__content');
        if (replacement) section.replaceWith(replacement);
      })
      .catch(() => { section.dataset.loaded = 'false'; });
  };

  const initializeRecommendations = () => {
    const observer = typeof IntersectionObserver === 'undefined' ? null : new IntersectionObserver((entries, activeObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        activeObserver.unobserve(entry.target);
        loadRecommendations(entry.target);
      });
    }, { rootMargin: '0px 0px 200px' });
    document.querySelectorAll('[data-uke-recommendations]').forEach((section) => {
      if (observer) observer.observe(section);
      else loadRecommendations(section);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeRecommendations, { once: true });
  else initializeRecommendations();
})();
